import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthHelper } from '@cation/core/auth/auth-helper';

@Component({
  selector: 'app-points-dialog',
  templateUrl: './points-dialog.component.html',
  styleUrls: ['./points-dialog.component.scss']
})
export class PointsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<PointsDialogComponent>,
    public auth: AuthHelper
  ) {}
}
